import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * The split layout exists to recover vertical space on constrained phones in landscape. Larger
 * canvases keep the standard layout even when they happen to be wider than they are tall.
 */
internal fun isConstrainedPhoneLandscape(width: Dp, height: Dp): Boolean =
    width > height && height < 520.dp && width < 1000.dp
